<template>
  <div class="principal-input-hora">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="time"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :disabled="deshabilitado"
          solo
          v-model="valorInternoMask"
          placeholder="00:00"
          append-icon="far fa-clock"
          @click:append="on.click"
          readonly
          v-bind="attrs"
          v-on="on"
          height="45px"
          :required="requerido"
        ></v-text-field>
      </template>
      <v-time-picker
        :disabled="deshabilitado"
        format="24hr"
        @change="ObtenerValor($event)"
        v-if="menu"
        v-model="valorInterno"
        color="#b8725a"
        @click:minute="$refs.menu.save(time)"
        :min="horaMinima"
      ></v-time-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "InputHora",
  props: {
    requerido: Boolean,
    horaMinima: String,
    deshabilitado: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val !== null) {
          this.valorInterno = val;
        }
      },
      immediate: true
    }
  },
  methods: {
    LimpiarTexto(){
      this.valorInternoMask = "";
      this.valorInterno = "";
    },
    ObtenerValor(evento) {
      this.$emit("input", evento);
      var hora = parseInt(this.valorInterno.substring(0,2));
      if(hora > 11) 
        this.valorInternoMask = this.valorInterno + " pm";
      else
        this.valorInternoMask = this.valorInterno + " am";
    }
  },
  data() {
    return {
      menu: false,
      valorInterno: "",
      valorInternoMask: "",
      time:null
    };
  }
};
</script>

<style scoped></style>
